import React, { PropsWithChildren } from 'react'
import { PopoverButton } from '@headlessui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import clsx from 'clsx'

type Props = {
  open: boolean
}

export default function DropdownButton({
  open,
  children,
}: PropsWithChildren<Props>) {
  return (
    <PopoverButton
      data-navigation-dropdown-trigger
      className="-m-3 inline-flex items-center gap-[7px] p-3 text-[15px] font-medium leading-[18px] text-[#0b0b0f] outline-none transition-colors duration-[360ms] ease-[cubic-bezier(0.22,0.55,0.28,1)] hover:text-[#2563eb] focus:outline-none focus-visible:outline-none"
    >
      {children}
      <FontAwesomeIcon
        icon={faChevronDown}
        aria-hidden="true"
        className={clsx(
          '!h-2 !w-2 text-[#82828b] transition-transform duration-[360ms] ease-[cubic-bezier(0.45,0,0.2,1)]',
          open && 'rotate-180',
        )}
      />
    </PopoverButton>
  )
}
